import ToastMessage from '@/components/toasts/ToastMessage';
import api from '@/services/ApiService';
import useDataStore from '@/store/data';
import { toast } from 'react-toastify';

export default function useApiDelete(schema) {
  const { remove } = useDataStore();

  const mutationFn = async (id) => {
    const { data: res } = await api.delete(`${schema}/${id}`);
    return { res, id };
  };

  const onSuccess = (result, id, notification) => {
    remove(id, `https://codemeta.de/schemas/${schema}`);

    if (notification) {
      toast.success(
        <ToastMessage
          title="Objekt gelöscht"
          subtitle="Die Daten wurden erfolgreich gelöscht."
        />,
      );
    }
    return result;
  };

  const onError = (error) => {
    toast.error(
      <ToastMessage title="Fehler beim Speichern" subtitle={error?.message} />,
    );
  };

  const mutateAsync = (data, notification = true) => {
    return mutationFn(data).then(
      ({ res, id, notification }) => onSuccess(res, id),
      onError,
    );
  };

  return { mutateAsync };
}
